<template>
  <v-menu offset-y left>
    <template v-slot:activator="props">
      <slot name="activator" v-bind="props" />
    </template>

    <v-list class="pa-0">
      <v-list-item v-for="preset in presets" :key="preset.text" class="pa-0" style="min-height: 0;">
        <div class="menu-link py-2 px-6 d-block u-label-1" @click="$emit('click:menu', preset.text)">
          {{ preset.text }}
        </div>
      </v-list-item>
      <v-list-item class="pa-0" style="min-height: 0;">
        <div class="menu-link py-2 px-6 d-block u-label-1" @click="$emit('click:add')">Add a Note</div>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
import Vue from 'vue'
import { NOTE_PRESETS } from '@/constants/note-presets'

export default Vue.extend({
  data() {
    return {
      presets: NOTE_PRESETS,
    }
  },
})
</script>

<style lang="scss" scoped>
.menu-link {
  transition: all 0.2s;
  color: $color-black;
  background-color: white;
  width: 176px;
  cursor: pointer;

  &:hover,
  &.router-link-active {
    background-color: #eef0fa;
  }
}
</style>
